module.exports = __webpack_public_path__ + "img/popup3tu1ios.e5214d96.png";